import type { TypedDocumentNode } from '@apollo/client';
import { gql, useQuery } from '@apollo/client';
import type { Query, QueryFilterWatchListArgs } from '@/types/GraphqlSchema';

const WATCHLIST_ASSET_FIELDS = `
  id
  legacyId
  displayName
  country {
    id
    displayName
    isoCode
  }
  reportUpdatedDate
  mAndAOpportunity
  formattedNpv
  formattedRemainingReserves
`;

type FilterWatchListQueryResult = Pick<Query, 'filterWatchList'>;

const FILTER_WATCHLIST_QUERY: TypedDocumentNode<
  FilterWatchListQueryResult,
  QueryFilterWatchListArgs
> = gql`
  query FilterWatchList(
    $assetLegacyIds: [ID!]
    $assetIsoCodes: [String!]
    $country: [String!]
    $company: [String!]
    $basin: [String!]
    $developmentStatus: [ID!]
    $developmentType: [ID!]
    $shoreStatus: [String!]
    $operator: Boolean
    $opportunities: Boolean
    $geologyEpochIds: [ID!]
    $hydrocarbonType: [String!]
    $includeHistoricalParticipants: Boolean
    $oilType: [String!]
    $npvMin: Float
    $npvMax: Float
    $reservesMin: Float
    $reservesMax: Float
    $productionMin: Float
    $productionMax: Float
    $depthMin: Float
    $depthMax: Float
    $sortType: String!
    $sortAscending: Boolean!
  ) {
    filterWatchList(
      assetLegacyIds: $assetLegacyIds
      assetIsoCodes: $assetIsoCodes
      country: $country
      company: $company
      basin: $basin
      developmentStatus: $developmentStatus
      developmentType: $developmentType
      shoreStatus: $shoreStatus
      operator: $operator
      opportunities: $opportunities
      geologyEpochIds: $geologyEpochIds
      hydrocarbonType: $hydrocarbonType
      includeHistoricalParticipants: $includeHistoricalParticipants
      oilType: $oilType
      npvMin: $npvMin
      npvMax: $npvMax
      reservesMin: $reservesMin
      reservesMax: $reservesMax
      productionMin: $productionMin
      productionMax: $productionMax
      depthMin: $depthMin
      depthMax: $depthMax
      sortType: $sortType
      sortAscending: $sortAscending
    ) {
      ${WATCHLIST_ASSET_FIELDS}
    }
  }
`;

const useWatchList = (variables: QueryFilterWatchListArgs) => {
  const { loading, data, refetch } = useQuery(FILTER_WATCHLIST_QUERY, {
    fetchPolicy: 'cache-and-network',
    variables,
  });

  const watchList = data?.filterWatchList ?? [];

  return {
    watchList,
    loading,
    refetch,
  };
};

export { useWatchList };
